import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getVessel',
    pure: true
})
export class GetVesselPipe implements PipeTransform {

    transform(item: any, ignoreRevision: boolean = false): any {
        return (ignoreRevision ? item?.vessel : item?.vesselRevision) || item?.vtsVessel || item?.serviceVessel || item?.serviceVtsVessel
            || (ignoreRevision ? item?.vesselNotification?.vessel : item?.vesselNotification?.vesselRevision)
            || (ignoreRevision ? item?.vtsVesselVisit?.vessel : item?.vtsVesselVisit?.vesselRevision)
            || item?.vtsVesselVisit?.vtsVessel;
    }
}
